import AssignTaskByRoleForm from "@/components/Forms/SubForms/AssignTaskByRoleForm.tsx";
import AssignTasksByTemplateForm from "@/components/Forms/SubForms/AssignTasksByTemplateForm.tsx";
import AssignTasksToSelfAdHocForm from "@/components/Forms/SubForms/AssignTasksToSelfAdHocForm.tsx";
import { a11yProps } from "@/components/Tabs/A11yProps.tsx";
import { CustomTabPanel } from "@/components/Tabs/CustomTabPanel.tsx";
import { useEmployee } from "@/contexts/EmployeeProvider.tsx";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import * as React from "react";
import { type ReactNode, useState } from "react";

type Props = {
    foundCaseId?: string;
    caseIdUUID?: string;
};

const BulkAssignTasksButton = ({ caseIdUUID, foundCaseId }: Props): ReactNode => {
    const { hasPermission } = useEmployee();
    const [value, setValue] = React.useState(0);
    const [open, setOpen] = useState(false);

    const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };

    const handleClose = () => {
        if (open) {
            setOpen(false);
        }
    };

    if (!hasPermission("bulk-assign:case-task")) {
        return null;
    }

    return (
        <>
            <Button
                variant={"contained"}
                sx={{
                    ml: 2,
                    minWidth: "120px",
                }}
                onClick={() => setOpen(true)}
            >
                Bulk Assign Tasks
            </Button>
            <Dialog open={open} maxWidth="md" fullWidth>
                <DialogTitle>Assign Tasks</DialogTitle>
                <DialogContent dividers>
                    <Box sx={{ width: "100%" }}>
                        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                            <Tabs
                                TabIndicatorProps={{
                                    sx: { display: "none" },
                                    style: {
                                        backgroundColor: "#D97D54",
                                    },
                                }}
                                value={value}
                                onChange={handleChange}
                                aria-label="Case Tabs"
                                sx={{
                                    "& .MuiTabs-flexContainer": {
                                        flexWrap: "wrap",
                                    },
                                }}
                                centered
                            >
                                <Tab label="Assign by Case Template" {...a11yProps(0)} />
                                <Tab label="Assign By Task" {...a11yProps(1)} />
                                <Tab label="Assign Ad Hoc" {...a11yProps(2)} />
                            </Tabs>
                        </Box>
                        <CustomTabPanel value={value} index={0}>
                            <AssignTasksByTemplateForm
                                handleClose={handleClose}
                                foundCaseId={foundCaseId}
                            />
                        </CustomTabPanel>
                        <CustomTabPanel value={value} index={1}>
                            <AssignTaskByRoleForm
                                handleClose={handleClose}
                                foundCaseId={foundCaseId}
                            />
                        </CustomTabPanel>
                        <CustomTabPanel value={value} index={2}>
                            <AssignTasksToSelfAdHocForm
                                foundCaseId={foundCaseId}
                                caseIdUUID={caseIdUUID}
                                adminMode={true}
                            />
                        </CustomTabPanel>
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => handleClose()}>Close</Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default BulkAssignTasksButton;
